// 2025(c) ESIEE Paris
// Author: CANDIA Nicolas <nicolas.candia@esiee.fr>

import * as df from "~date-fns";

const dateFormat = 'yyyy-MM-dd';

var bind_date_range_input = function(el) {

    el.addEventListener('change', function(e) {
        const today_now = new Date();

        let self = e.target;

        let beginInput = document.getElementById(self.dataset.begin);
        let endInput = document.getElementById(self.dataset.end);

        if (self.value == "day") 
        {
            beginInput.value = df.format(today_now, dateFormat);
            endInput.value = "";
        } 
        else if (self.value == "last_day") 
        {
            beginInput.value = df.format(
                df.sub(today_now, { days: 1 }), 
                dateFormat
            );

            endInput.value = df.format(
                df.sub(today_now, { days: 1 }), 
                dateFormat
            );
        } 
        else if (self.value == "week")
        {
            beginInput.value = df.format(
                df.add(df.startOfWeek(today_now), { days: 1 }),
                dateFormat
            );

            endInput.value = df.format(
                df.add(df.endOfWeek(today_now), { days: 1}),
                dateFormat
            );
        } 
        else if (self.value == "last_week")
        {
            beginInput.value = df.format(
                df.add(
                    df.startOfWeek(df.sub(today_now, { days: 7 })),
                    { days: 1 }
                ),
                dateFormat
            );

            endInput.value = df.format(
                df.add(
                    df.endOfWeek(df.sub(today_now, { days: 7 })),
                    { days: 1 }
                ),
                dateFormat
            );
        }
        else if (self.value == "month")
        {
            beginInput.value = df.format(
                df.startOfMonth(today_now),
                dateFormat
            );

            endInput.value = df.format(
                df.endOfMonth(today_now),
                dateFormat
            );
        }
        else if (self.value == "last_month")
        {
            beginInput.value = df.format(
                df.startOfMonth(df.sub(today_now, { months: 1 })),
                dateFormat
            );

            endInput.value = df.format(
                df.endOfMonth(df.sub(today_now, { months: 1 })),
                dateFormat
            );
        }
        else if (self.value == "year")
        {
            beginInput.value = df.format(
                df.startOfYear(today_now),
                dateFormat
            );

            endInput.value = df.format(
                df.endOfYear(today_now),
                dateFormat
            );
        }
        else if (self.value == "last_year")
        {
            beginInput.value = df.format(
                df.startOfYear(df.sub(today_now, { years: 1 })),
                dateFormat
            );

            endInput.value = df.format(
                df.endOfYear(df.sub(today_now, { years: 1 })),
                dateFormat
            );
        }
        else if (self.value == "year_scholar")
        {
            if (today_now.getMonth() < 8)
            {
                beginInput.value = df.format(
                    df.setMonth(
                        df.setDate(
                            df.sub(today_now, { years: 1 }), 1
                        ), 8
                    ),
                    dateFormat
                );

                endInput.value = df.format(
                    df.setMonth(
                        df.setDate(today_now, 31), 7
                    ),
                    dateFormat
                );
            }
            else
            {
                beginInput.value = df.format(
                    df.setMonth(
                        df.setDate(today_now, 1), 8
                    ),
                    dateFormat
                );

                endInput.value = df.format(
                    df.setMonth(
                        df.add(df.setDate(today_now, 31), { years: 1 }), 7
                    ),
                    dateFormat
                );
            }
        }
        else {
            beginInput.value = "";
            endInput.value = "";
        }
    });
    
};

export function init() {

    // Bind range select to date fields
    document.querySelectorAll('.date-range').forEach(el => {
        bind_date_range_input(el);
    });

}